<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="10" align="start">
        <v-card outlined elevation="0" v-if="note">
          <v-card-title>
            Détails de votre session
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text><b>Date : </b>{{ formatedDate }}</v-card-text>
          <v-card-text><b>Note : </b>{{ note }}</v-card-text>
        </v-card>
        <v-card outlined elevation="0" v-if="note == ''">
          <v-card-text align="center">
            Pas d'entraînement enregistré pour le {{ formatedDate }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import format from "date-fns/format";
import fr from "date-fns/locale/fr";

export default {
  props: {
    date: {
      type: String,
      default: new Date()
    },
    note: {
      type: String
    }
  },
  computed: {
    formatedDate() {
      return format(new Date(this.date), "EEEE dd MMMM yyyy", {
        locale: fr
      });
    }
  }
};
</script>

<style scoped>
</style>